























































import { Component, Inject } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { OrderEntity } from '@/entities/order.entity';
import { sidebarConfig } from '@/config/sidebar';
import CashIcon from '@/components/Helper/Icon/Svg/CashIcon.vue';
import { TranslateResult } from 'vue-i18n';

const joins = ['products', 'status'];

const order: [string, 'DESC' | 'ASC'][] = [['createdAt', 'DESC']];

@Component<History>({
  components: { CashIcon },
})
export default class History extends CreateListDataMixin<OrderEntity>(
  'order',
  'order',
  joins,
  order,
) {
  // items: OrderEntity[]

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  get orders(): OrderEntity[] {
    return this.items.filter(
      (item) => !!item.products && item.products.length > 0,
    );
  }

  get containerWidth(): string {
    return this.$vuetify.breakpoint.mobile
      ? '100%'
      : `calc(100% - ${sidebarConfig.width}px - 48px)`;
  }

  orderStatus(isComplete): TranslateResult {
    return isComplete
      ? this.$t('order.statuses.completed')
      : this.$t('order.statuses.new');
  }
}
